import { Translate } from 'next-translate';

import { Lot } from 'types';

interface PreviewTooltipParams {
  hasSuppliers: boolean;
  name?: string;
  originalLots?: Lot[];
  t: Translate;
}

export const previewTooltip = ({
  t,
  hasSuppliers,
  name,
  originalLots
}: PreviewTooltipParams) => {
  const reasons = [];
  if (!hasSuppliers) {
    reasons.push(t('bid_request.line_items.tooltips.reasons.no_suppliers'));
  }
  if (!originalLots?.length) {
    reasons.push(t('bid_request.line_items.tooltips.reasons.no_lots_persisted'));
  }

  if (!reasons.length) return '';

  return t('bid_request.line_items.tooltips.disabled_with_reason', {
    name: name ?? t('general.preview_supplier_pricing'),
    reason: reasons.join(', '),
  });
};
